import {withModalProvider} from "../../hoc/withModalProvider";
import {UserRemoveButton as View, UserRemoveButtonProps} from "./UserRemoveButton";

export const UserRemoveButton = withModalProvider<UserRemoveButtonProps>(View);